import { VAlert } from 'vuetify/lib/components/VAlert';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VDatePicker } from 'vuetify/lib/components/VDatePicker';
import { VForm } from 'vuetify/lib/components/VForm';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VMenu } from 'vuetify/lib/components/VMenu';
import { VProgressLinear } from 'vuetify/lib/components/VProgressLinear';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VSubheader } from 'vuetify/lib/components/VSubheader';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTooltip } from 'vuetify/lib/components/VTooltip';

var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "min-w-0 w-full" },
    [
      _c("div", { staticClass: "display-1" }, [
        _vm._v(_vm._s(_vm.$t("menu.dp.up_user_profile"))),
      ]),
      _c(
        "actions-component",
        { attrs: { class_table: _vm.getClassTable } },
        [
          _c(
            "template",
            { slot: "actions" },
            [
              _c(
                VBtn,
                {
                  staticClass: "ml-1 btn-inca-secondary",
                  attrs: { dense: "", outlined: "" },
                  on: {
                    click: function ($event) {
                      return _vm.showModal(false, "create")
                    },
                  },
                },
                [
                  _c(VIcon, { attrs: { small: "" } }, [_vm._v("icon-add")]),
                  _vm._v(_vm._s(_vm.$t("botones.boton_crear"))),
                ],
                1
              ),
              _c(
                VBtn,
                {
                  staticClass: "ml-1 btn-inca-secondary",
                  attrs: { dense: "", outlined: "" },
                  on: { click: _vm.onEnableFilter },
                },
                [
                  _vm.filter_enabled
                    ? _c(VIcon, { attrs: { small: "" } }, [
                        _vm._v("mdi-filter-off-outline"),
                      ])
                    : _vm._e(),
                  !_vm.filter_enabled
                    ? _c(VIcon, { attrs: { small: "" } }, [
                        _vm._v("mdi-filter-outline"),
                      ])
                    : _vm._e(),
                  _vm._v(_vm._s(_vm.$t("botones.boton_filtrar"))),
                ],
                1
              ),
            ],
            1
          ),
        ],
        2
      ),
      _vm.filter_enabled
        ? _c(
            VCard,
            { staticClass: "d-block d-md-none mb-2" },
            [
              _c(VCardTitle, { staticClass: "pointer" }, [
                _vm._v(_vm._s(_vm.$t("titles.search_filters"))),
              ]),
              _c(
                VCardText,
                { staticClass: "pa-2" },
                [
                  _c(
                    VRow,
                    { attrs: { dense: "" } },
                    [
                      _c(
                        "div",
                        { staticClass: "col-md-3" },
                        [
                          _c(VTextField, {
                            attrs: {
                              label: _vm.texts.name,
                              placeholder: _vm.texts.name,
                              outlined: "",
                              dense: "",
                            },
                            on: {
                              keyup: function ($event) {
                                if (
                                  !$event.type.indexOf("key") &&
                                  _vm._k(
                                    $event.keyCode,
                                    "enter",
                                    13,
                                    $event.key,
                                    "Enter"
                                  )
                                ) {
                                  return null
                                }
                                return _vm.onSearch($event)
                              },
                            },
                            model: {
                              value: _vm.filters.nombre,
                              callback: function ($$v) {
                                _vm.$set(_vm.filters, "nombre", $$v)
                              },
                              expression: "filters.nombre",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "div",
                        { staticClass: "col-md-3" },
                        [
                          _c(VTextField, {
                            attrs: {
                              label: "Area",
                              items: _vm.area_filter,
                              outlined: "",
                              dense: "",
                            },
                            model: {
                              value: _vm.filters.area,
                              callback: function ($$v) {
                                _vm.$set(_vm.filters, "area", $$v)
                              },
                              expression: "filters.area",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        VCol,
                        { staticClass: "mb-2 col-md-3" },
                        [
                          _c(
                            VMenu,
                            {
                              ref: "menu",
                              attrs: {
                                "close-on-content-click": false,
                                "return-value": _vm.dates,
                                transition: "scale-transition",
                                "offset-y": "",
                                "max-width": "290px",
                                "min-width": "290px",
                              },
                              on: {
                                "update:returnValue": function ($event) {
                                  _vm.dates = $event
                                },
                                "update:return-value": function ($event) {
                                  _vm.dates = $event
                                },
                              },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "activator",
                                    fn: function (ref) {
                                      var on = ref.on
                                      var attrs = ref.attrs
                                      return [
                                        _c(
                                          VTextField,
                                          _vm._g(
                                            _vm._b(
                                              {
                                                attrs: {
                                                  "append-icon": "event",
                                                  readonly: "",
                                                  dense: "",
                                                  outlined: "",
                                                  "hide-details": "auto",
                                                  label: _vm.texts.rango,
                                                },
                                                model: {
                                                  value: _vm.dateRangeText,
                                                  callback: function ($$v) {
                                                    _vm.dateRangeText = $$v
                                                  },
                                                  expression: "dateRangeText",
                                                },
                                              },
                                              "v-text-field",
                                              attrs,
                                              false
                                            ),
                                            on
                                          )
                                        ),
                                      ]
                                    },
                                  },
                                ],
                                null,
                                false,
                                3434742011
                              ),
                              model: {
                                value: _vm.menu,
                                callback: function ($$v) {
                                  _vm.menu = $$v
                                },
                                expression: "menu",
                              },
                            },
                            [
                              _c(
                                VDatePicker,
                                {
                                  attrs: { range: "", scrollabel: "" },
                                  model: {
                                    value: _vm.filters.fechas,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.filters, "fechas", $$v)
                                    },
                                    expression: "filters.fechas",
                                  },
                                },
                                [
                                  _c(VSpacer),
                                  _c(
                                    VBtn,
                                    {
                                      attrs: { text: "", color: "primary" },
                                      on: {
                                        click: function ($event) {
                                          _vm.menu = false
                                        },
                                      },
                                    },
                                    [_vm._v(_vm._s(_vm.$t("btns.cancel")))]
                                  ),
                                  _c(
                                    VBtn,
                                    {
                                      attrs: { text: "", color: "primary" },
                                      on: {
                                        click: function ($event) {
                                          _vm.menu = false
                                        },
                                      },
                                    },
                                    [_vm._v(_vm._s(_vm.$t("btns.ok")))]
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "div",
                        { staticClass: "col-md-3 text-right" },
                        [
                          _c(
                            VBtn,
                            {
                              staticClass: "default mr-1",
                              attrs: { outlined: "" },
                              on: { click: _vm.onLimpiar },
                            },
                            [_vm._v(_vm._s(_vm.$t("btns.clean")))]
                          ),
                          _c(
                            VBtn,
                            {
                              staticClass: "primary ",
                              on: { click: _vm.onSearch },
                            },
                            [_vm._v(_vm._s(_vm.$t("btns.search")))]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
      _c(
        VRow,
        [
          _c(
            "div",
            { class: _vm.getClassTable },
            [
              _c(
                VCard,
                [
                  _c(VDataTable, {
                    staticClass: "table-inca",
                    attrs: {
                      headers: _vm.headers,
                      items: _vm.select_profile_users,
                      "item-class": _vm.rowClassFlag,
                      "disable-pagination": "",
                      "hide-default-footer": "",
                      "items-per-page": _vm.pagination.limit,
                      page: _vm.pagination.current,
                    },
                    on: {
                      pagination: function ($event) {
                        _vm.pagination.total = $event.itemsLength
                      },
                      "update:page": function ($event) {
                        return _vm.$set(_vm.pagination, "current", $event)
                      },
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "item.load_date",
                        fn: function (ref) {
                          var item = ref.item
                          return [
                            _c("span", [
                              _vm._v(
                                _vm._s(
                                  new Date(item.load_date).toLocaleString(
                                    "en-GB"
                                  )
                                )
                              ),
                            ]),
                          ]
                        },
                      },
                      {
                        key: "item.actions",
                        fn: function (data) {
                          return [
                            _c(
                              VTooltip,
                              {
                                attrs: { bottom: "" },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "activator",
                                      fn: function (ref) {
                                        var on = ref.on
                                        var attrs = ref.attrs
                                        return [
                                          _c(
                                            VBtn,
                                            _vm._g(
                                              _vm._b(
                                                {
                                                  staticClass: "btn-icon-inca",
                                                  attrs: {
                                                    icon: "",
                                                    small: "",
                                                  },
                                                  on: {
                                                    click: function ($event) {
                                                      return _vm.showModal(
                                                        data,
                                                        "view"
                                                      )
                                                    },
                                                  },
                                                },
                                                "v-btn",
                                                attrs,
                                                false
                                              ),
                                              on
                                            ),
                                            [
                                              _c(VIcon, [
                                                _vm._v("icon-view"),
                                              ]),
                                            ],
                                            1
                                          ),
                                        ]
                                      },
                                    },
                                  ],
                                  null,
                                  true
                                ),
                              },
                              [_c("span", [_vm._v("View Profile")])]
                            ),
                            _c(
                              VTooltip,
                              {
                                attrs: { bottom: "" },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "activator",
                                      fn: function (ref) {
                                        var on = ref.on
                                        var attrs = ref.attrs
                                        return [
                                          _c(
                                            VBtn,
                                            _vm._g(
                                              _vm._b(
                                                {
                                                  staticClass: "btn-icon-inca",
                                                  attrs: {
                                                    icon: "",
                                                    small: "",
                                                  },
                                                  on: {
                                                    click: function ($event) {
                                                      return _vm.showModal(
                                                        data,
                                                        "edit"
                                                      )
                                                    },
                                                  },
                                                },
                                                "v-btn",
                                                attrs,
                                                false
                                              ),
                                              on
                                            ),
                                            [
                                              _c(VIcon, [
                                                _vm._v("icon-edit"),
                                              ]),
                                            ],
                                            1
                                          ),
                                        ]
                                      },
                                    },
                                  ],
                                  null,
                                  true
                                ),
                              },
                              [_c("span", [_vm._v("Edit Profile")])]
                            ),
                            _c(
                              VTooltip,
                              {
                                attrs: { bottom: "" },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "activator",
                                      fn: function (ref) {
                                        var on = ref.on
                                        var attrs = ref.attrs
                                        return [
                                          _c(
                                            VBtn,
                                            _vm._g(
                                              _vm._b(
                                                {
                                                  staticClass: "btn-icon-inca",
                                                  attrs: {
                                                    icon: "",
                                                    small: "",
                                                  },
                                                  on: {
                                                    click: function ($event) {
                                                      return _vm.onDelete(
                                                        data.item
                                                      )
                                                    },
                                                  },
                                                },
                                                "v-btn",
                                                attrs,
                                                false
                                              ),
                                              on
                                            ),
                                            [
                                              _c(VIcon, [
                                                _vm._v("icon-delete"),
                                              ]),
                                            ],
                                            1
                                          ),
                                        ]
                                      },
                                    },
                                  ],
                                  null,
                                  true
                                ),
                              },
                              [_c("span", [_vm._v("Delete Profile")])]
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                ],
                1
              ),
              _c("pagination-vue", { attrs: { pagination: _vm.pagination } }),
            ],
            1
          ),
          _vm.filter_enabled
            ? _c(
                "div",
                { staticClass: "col-md-3 d-none d-md-block pl-0" },
                [
                  _c(
                    VCard,
                    { staticClass: "filters-inca" },
                    [
                      _c(
                        VCardTitle,
                        {
                          staticClass: "pointer",
                          on: {
                            click: function ($event) {
                              _vm.collapse_filter = !_vm.collapse_filter
                            },
                          },
                        },
                        [_vm._v(_vm._s(_vm.$t("titles.search_filters")))]
                      ),
                      _c(
                        VCardText,
                        { staticClass: "pa-2 pt-0" },
                        [
                          _c(
                            VRow,
                            { attrs: { dense: "" } },
                            [
                              _c(
                                VCol,
                                { attrs: { cols: "12" } },
                                [
                                  _c(VTextField, {
                                    attrs: {
                                      label: _vm.texts.name,
                                      placeholder: _vm.texts.name,
                                      outlined: "",
                                      dense: "",
                                    },
                                    on: {
                                      keyup: function ($event) {
                                        if (
                                          !$event.type.indexOf("key") &&
                                          _vm._k(
                                            $event.keyCode,
                                            "enter",
                                            13,
                                            $event.key,
                                            "Enter"
                                          )
                                        ) {
                                          return null
                                        }
                                        return _vm.onSearch($event)
                                      },
                                    },
                                    model: {
                                      value: _vm.filters.nombre,
                                      callback: function ($$v) {
                                        _vm.$set(_vm.filters, "nombre", $$v)
                                      },
                                      expression: "filters.nombre",
                                    },
                                  }),
                                ],
                                1
                              ),
                              _c(
                                VCol,
                                { attrs: { cols: "12" } },
                                [
                                  _c(VTextField, {
                                    attrs: {
                                      label: "Area",
                                      items: _vm.area_filter,
                                      outlined: "",
                                      dense: "",
                                    },
                                    model: {
                                      value: _vm.filters.area,
                                      callback: function ($$v) {
                                        _vm.$set(_vm.filters, "area", $$v)
                                      },
                                      expression: "filters.area",
                                    },
                                  }),
                                ],
                                1
                              ),
                              _c(
                                VCol,
                                { staticClass: "mb-2", attrs: { cols: "12" } },
                                [
                                  _c(
                                    VMenu,
                                    {
                                      ref: "menu2",
                                      attrs: {
                                        "close-on-content-click": false,
                                        "return-value": _vm.dates,
                                        transition: "scale-transition",
                                        "offset-y": "",
                                        "max-width": "290px",
                                        "min-width": "290px",
                                      },
                                      on: {
                                        "update:returnValue": function (
                                          $event
                                        ) {
                                          _vm.dates = $event
                                        },
                                        "update:return-value": function (
                                          $event
                                        ) {
                                          _vm.dates = $event
                                        },
                                      },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "activator",
                                            fn: function (ref) {
                                              var on = ref.on
                                              var attrs = ref.attrs
                                              return [
                                                _c(
                                                  VTextField,
                                                  _vm._g(
                                                    _vm._b(
                                                      {
                                                        attrs: {
                                                          "append-icon":
                                                            "event",
                                                          readonly: "",
                                                          dense: "",
                                                          outlined: "",
                                                          "hide-details":
                                                            "auto",
                                                          label:
                                                            _vm.texts.rango,
                                                        },
                                                        model: {
                                                          value:
                                                            _vm.dateRangeText,
                                                          callback: function (
                                                            $$v
                                                          ) {
                                                            _vm.dateRangeText =
                                                              $$v
                                                          },
                                                          expression:
                                                            "dateRangeText",
                                                        },
                                                      },
                                                      "v-text-field",
                                                      attrs,
                                                      false
                                                    ),
                                                    on
                                                  )
                                                ),
                                              ]
                                            },
                                          },
                                        ],
                                        null,
                                        false,
                                        3434742011
                                      ),
                                      model: {
                                        value: _vm.menu2,
                                        callback: function ($$v) {
                                          _vm.menu2 = $$v
                                        },
                                        expression: "menu2",
                                      },
                                    },
                                    [
                                      _c(
                                        VDatePicker,
                                        {
                                          attrs: { range: "", scrollabel: "" },
                                          model: {
                                            value: _vm.filters.fechas,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.filters,
                                                "fechas",
                                                $$v
                                              )
                                            },
                                            expression: "filters.fechas",
                                          },
                                        },
                                        [
                                          _c(VSpacer),
                                          _c(
                                            VBtn,
                                            {
                                              attrs: {
                                                text: "",
                                                color: "primary",
                                              },
                                              on: {
                                                click: function ($event) {
                                                  _vm.menu2 = false
                                                },
                                              },
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(_vm.$t("btns.cancel"))
                                              ),
                                            ]
                                          ),
                                          _c(
                                            VBtn,
                                            {
                                              attrs: {
                                                text: "",
                                                color: "primary",
                                              },
                                              on: {
                                                click: function ($event) {
                                                  _vm.menu2 = false
                                                },
                                              },
                                            },
                                            [_vm._v(_vm._s(_vm.$t("btns.ok")))]
                                          ),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _c(
                                VCol,
                                {
                                  staticClass: "text-right",
                                  attrs: { cols: "12" },
                                },
                                [
                                  _c(
                                    VBtn,
                                    {
                                      staticClass: "default mr-1",
                                      attrs: { outlined: "" },
                                      on: { click: _vm.onLimpiar },
                                    },
                                    [_vm._v(_vm._s(_vm.$t("btns.clean")))]
                                  ),
                                  _c(
                                    VBtn,
                                    {
                                      staticClass: "primary ",
                                      on: { click: _vm.onSearch },
                                    },
                                    [_vm._v(_vm._s(_vm.$t("btns.search")))]
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
          _c("dialog-confirmation-component", {
            ref: "dialogConfirmation",
            attrs: { title: _vm.$t("frases.sure") },
            on: { onConfirm: _vm.onConfirmDelete },
          }),
          _c(
            "DialogsComponent",
            { ref: "dialog", attrs: { title: _vm.modalTitle, width: 800 } },
            [
              _c(
                "template",
                { slot: "body" },
                [
                  _c(
                    VForm,
                    { ref: "form" },
                    [
                      _c(
                        VRow,
                        { attrs: { dense: "" } },
                        [
                          _c(
                            VCol,
                            { attrs: { sm: "12", lg: "12" } },
                            [
                              _c(
                                VRow,
                                { attrs: { dense: "", justify: "center" } },
                                [
                                  _c(
                                    VCol,
                                    { staticClass: "col-md-3" },
                                    [
                                      _c(
                                        VSubheader,
                                        { staticClass: "font-weight-bold p-0" },
                                        [
                                          _vm._v(
                                            _vm._s(_vm.$t("tablas.name")) + " :"
                                          ),
                                        ]
                                      ),
                                    ],
                                    1
                                  ),
                                  _c(
                                    VCol,
                                    { staticClass: "col-md-9" },
                                    [
                                      _c(VTextField, {
                                        attrs: {
                                          dense: "",
                                          outlined: !_vm.readonly,
                                          readonly: _vm.readonly,
                                          filled: _vm.readonly,
                                          rules: [
                                            function (v) {
                                              return (
                                                !!v || "This field is required"
                                              )
                                            },
                                          ],
                                        },
                                        model: {
                                          value:
                                            _vm.record.userprofile_description,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.record,
                                              "userprofile_description",
                                              typeof $$v === "string"
                                                ? $$v.trim()
                                                : $$v
                                            )
                                          },
                                          expression:
                                            "record.userprofile_description",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        VRow,
                        { attrs: { dense: "" } },
                        [
                          _c(
                            VCol,
                            { attrs: { sm: "12", lg: "12" } },
                            [
                              _c(
                                VRow,
                                { attrs: { dense: "", justify: "center" } },
                                [
                                  _c(
                                    VCol,
                                    { staticClass: "col-md-3" },
                                    [
                                      _c(
                                        VSubheader,
                                        { staticClass: "font-weight-bold p-0" },
                                        [
                                          _vm._v(
                                            _vm._s(_vm.$t("tablas.area")) + " :"
                                          ),
                                        ]
                                      ),
                                    ],
                                    1
                                  ),
                                  _c(
                                    VCol,
                                    { staticClass: "col-md-9" },
                                    [
                                      _c(VSelect, {
                                        attrs: {
                                          dense: "",
                                          items: _vm.select_areas,
                                          required: "",
                                          outlined: !_vm.readonly,
                                          readonly: _vm.readonly,
                                          filled: _vm.readonly,
                                          value: _vm.record.area_id,
                                          rules: [
                                            function (v) {
                                              return (
                                                !!v || "This field is required"
                                              )
                                            },
                                          ],
                                        },
                                        model: {
                                          value: _vm.record.area_id,
                                          callback: function ($$v) {
                                            _vm.$set(_vm.record, "area_id", $$v)
                                          },
                                          expression: "record.area_id",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        VRow,
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.showMonitoringInput,
                              expression: "showMonitoringInput",
                            },
                          ],
                          attrs: { dense: "" },
                        },
                        [
                          _c(
                            VCol,
                            { attrs: { sm: "12", lg: "12" } },
                            [
                              _c(
                                VRow,
                                { attrs: { dense: "", justify: "center" } },
                                [
                                  _c(
                                    VCol,
                                    { staticClass: "col-md-3" },
                                    [
                                      _c(
                                        VSubheader,
                                        { staticClass: "font-weight-bold p-0" },
                                        [
                                          _vm._v(
                                            _vm._s(_vm.$t("frases.activo")) +
                                              " :"
                                          ),
                                        ]
                                      ),
                                    ],
                                    1
                                  ),
                                  _c(
                                    VCol,
                                    { staticClass: "col-md-9" },
                                    [
                                      _c(VCheckbox, {
                                        attrs: {
                                          name: "checkbox-active",
                                          disabled: _vm.readonly,
                                        },
                                        model: {
                                          value: _vm.record.flag_active,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.record,
                                              "flag_active",
                                              $$v
                                            )
                                          },
                                          expression: "record.flag_active",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        VRow,
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.showMonitoringInput,
                              expression: "showMonitoringInput",
                            },
                          ],
                          staticClass: "border pt-2",
                          attrs: { dense: "" },
                        },
                        [
                          _c(
                            VCol,
                            { attrs: { sm: "12", lg: "6" } },
                            [
                              _c(
                                VRow,
                                { attrs: { dense: "", justify: "center" } },
                                [
                                  _c(
                                    VCol,
                                    { staticClass: "col-md-4" },
                                    [
                                      _c(
                                        VSubheader,
                                        { staticClass: "font-weight-bold p-0" },
                                        [
                                          _vm._v(
                                            _vm._s(_vm.texts.updated_by) + " :"
                                          ),
                                        ]
                                      ),
                                    ],
                                    1
                                  ),
                                  _c(
                                    VCol,
                                    { staticClass: "col-md-8" },
                                    [
                                      _c(VTextField, {
                                        attrs: { disabled: true, size: "sm" },
                                        model: {
                                          value: _vm.record.creator_user,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.record,
                                              "creator_user",
                                              $$v
                                            )
                                          },
                                          expression: "record.creator_user",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            VCol,
                            { attrs: { sm: "12", lg: "6" } },
                            [
                              _c(
                                VRow,
                                { attrs: { dense: "", justify: "center" } },
                                [
                                  _c(
                                    VCol,
                                    { staticClass: "col-md-4" },
                                    [
                                      _c(
                                        VSubheader,
                                        { staticClass: "font-weight-bold p-0" },
                                        [
                                          _vm._v(
                                            _vm._s(_vm.texts.update_date) + " :"
                                          ),
                                        ]
                                      ),
                                    ],
                                    1
                                  ),
                                  _c(
                                    VCol,
                                    { staticClass: "col-md-8" },
                                    [
                                      _c(VTextField, {
                                        attrs: {
                                          type: "datetime",
                                          disabled: true,
                                          size: "sm",
                                        },
                                        model: {
                                          value: _vm.record.load_date,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.record,
                                              "load_date",
                                              $$v
                                            )
                                          },
                                          expression: "record.load_date",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        VRow,
                        [
                          _c(
                            VCol,
                            { attrs: { cols: "12" } },
                            [
                              _c(
                                VAlert,
                                {
                                  attrs: {
                                    value: _vm.alert,
                                    dismissible: "",
                                    color: "danger",
                                    transition: "slide-y-transition",
                                  },
                                  on: { input: _vm.dismissible_close },
                                },
                                [
                                  _c("p", [_vm._v(_vm._s(_vm.dangerMessage))]),
                                  _c(VProgressLinear, {
                                    attrs: { value: _vm.dismissCountDown },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              !_vm.readonly
                ? _c(
                    "template",
                    { slot: "btnsRight" },
                    [
                      _c(
                        VBtn,
                        {
                          staticClass: "primary",
                          attrs: { color: "primary" },
                          on: { click: _vm.handleSubmit },
                        },
                        [
                          _c(VIcon, [_vm._v("icon-send")]),
                          _vm._v(_vm._s(_vm.$t("botones.boton_aceptar"))),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            2
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }